import { Dialog, ThemeProvider } from '@mui/material'
import './WarningPopup.scss';
import { theme } from '../../utils/constants';
import { FC } from 'react';
import { getScreenDimensions } from '../../utils/helper';
import images from '../../assets/images';

interface propsType{
  openWarningPopup: boolean;
  closeWarnPopup: () => void;
  message: string;
  gifData?: string;
}
 
const WarningPopup: FC<propsType> = ({ openWarningPopup, closeWarnPopup, message, gifData }) => {

  const { closeIcon } = images;
  const { isMobileScreen } = getScreenDimensions();

  return (
    <ThemeProvider theme={theme}>
      <Dialog open={openWarningPopup} classes={{ paper: 'warnPaperStyle' }}>
        <div className={`warningContainer ${ gifData && "messageGap" }`}>
          <img src={closeIcon} className="closeIcon" onClick={closeWarnPopup} />
          <div className='messageMainContainer'>
            {gifData && <img className='gifContainer' src={gifData} alt='Gif' height={100}/>}
            <div className='messageContainer' style={{ fontSize: (message.includes("The meeting will be automatically ended on scheduled time")) ? '16px' : ''}}>
              { message }
            </div>
          </div>
          <button className='okButtonStyle' onClick={closeWarnPopup}>
            Okay
          </button>
        </div>
      </Dialog>
    </ThemeProvider>
  )
}

export default WarningPopup;
